import React from 'react'
/* import video from '../../../asset/backvideo.mp4' */

const Nft = () => {
  return (
    <div className='chamber'>
      <div className="video">
        <video autoPlay muted loop id="video">
          {/* <source src={video} type="video/mp4" /> */}
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="content">
        <h1>3.0 NFT BASICS</h1>
        <article>
            <a href="https://twitter.com/feyi_x/status/1487451682443341830?s=46" target="_blank" rel="noopener noreferrer">3.1 What Are NFTs?</a>
            <a href="https://opensea.io/learn/what-is-minting-nft" target="_blank" rel="noopener noreferrer">3.2 What Is Minting And How Do I Mint An NFT?</a>
            <a href="https://cointelegraph.com/news/what-is-an-nft-whitelist-and-how-can-you-join-one" target="_blank" rel="noopener noreferrer">3.3 What Is Whitelist?</a>
            <a href="https://www.fool.com/investing/stock-market/market-sectors/financials/non-fungible-tokens/nft-gas-fees/" target="_blank" rel="noopener noreferrer">3.4 What Is Gas Fee?</a>
            <a href="https://help.magiceden.io/en/articles/6509737-protecting-yourself-from-nft-scams-a-guide-to-identifying-and-avoiding-fraudulent-airdrops" target="_blank" rel="noopener noreferrer">3.5 How Do I Avoid Scams?</a>
            <a href="https://twitter.com/feyi_x/status/1514258635446235142?s=46" target="_blank" rel="noopener noreferrer">3.6 How To Mint An NFT From Contract?</a>
            <a href="https://twitter.com/feyi_x/status/1489671754926731265?s=46" target="_blank" rel="noopener noreferrer">3.7 How To Cancel A Transaction Using Nonce.</a>
            <a href="https://support.opensea.io/hc/en-us/articles/360063498313-How-do-I-create-an-NFT" target="_blank" rel="noopener noreferrer">3.8 Creating NFTs</a>
            <a href="https://support.opensea.io/hc/en-us/articles/360063498313-How-do-I-create-an-NFT" target="_blank" rel="noopener noreferrer">3.9 NFT Marketplaces</a>
            <a href="https://twitter.com/emmanelonuoha/status/1548964111282847746?s=46" target="_blank" rel="noopener noreferrer">3.10 What are Blue Chip NFTs</a>
            <a href="https://twitter.com/centronob/status/1612460912211886082?s=46" target="_blank" rel="noopener noreferrer">3.11 How To Use NFT Track</a>
            <a href="https://www.binance.com/en/blog/nft/a-guide-to-nft-rarity-9071635817709795895" target="_blank" rel="noopener noreferrer">3.12 How To Check NFT Rarity</a>
            <a href="https://cointelegraph.com/explained/what-are-nft-royalties-and-how-do-they-work" target="_blank" rel="noopener noreferrer">3.13 Royalties In NFT </a>
        </article>
      </div>

    </div>
  )
}

export default Nft
